import React, { useEffect, useState } from "react";
import axios from "axios";
import { UserConsumer } from "../../UserContext";
import { myOfficeHoursAPIs } from "./myOfficeHoursAPIs";
import WeeklyHours from "./WeeklyHours";
import StatusBar from "./StatusBar";
import HoursTable from "./HoursTable";
import moment from "moment";
import Header from "../../components/Header";
import { AlertPopups } from "../../components/AlertPopups";
import { useParams, useLocation } from "react-router-dom";
import MonthlyPercentage from "./MonthlyPercentage";
import {
	GlobalPaginationSize,
	getPaginationSizeOnRole,
} from "../../components/GlobalPaginationSize";
import { APIDateFormat } from "../Dashboard/DashboardVariables";

const OfficeHours = () => {
	let token,
		empDesignation = null;
	const params = useParams();
	let WorkStationId = params.id;
	let StatusID = new URLSearchParams(useLocation().search).get("Status");
	let currentDate = new Date();

	const [startDate, setStartDate] = useState(
		WorkStationId || StatusID // If redirected from My Dashboard set to 1 month
			? new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)
			: new Date(
					currentDate.getFullYear(),
					currentDate.getMonth(),
					currentDate.getDate() - 14
			  )
	);
	const [endDate, setEndDate] = useState(currentDate);
	const [pagerData, setPagerData] = useState(null);
	const [weekHours, setWeekHours] = useState({
		lastWeekMinutes: "00:00",
		currentWeekMinutes: "00:00",
		currentMonthMinutes: "0000",
		expectedHours: "0000",
	});
	const [WFOPercentage, setWFOPercentage] = useState({
		lastMonthWorkFromOfficePercentage: "00:00",
		thisMonthWorkFromOfficePercentage: "00:00",
		totalWorkFromOfficePercentage: "0000",
	});
	const defaultSorted = [
		{
			dataField: "recordDate",
			order: "desc",
		},
	];
	const [sortBy, setSortBy] = useState(defaultSorted[0]);
	const [totalHours, setTotalHours] = useState(null);
	const [status, setStatus] = useState();
	const [selectedStatus, setselectedStatus] = useState({
		value: 0,
		label: "All",
	});
	const [officeHours, setOfficeHours] = useState([]);
	const [missingCheckOut, setMissingCheckOut] = useState([]);
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(
		GlobalPaginationSize.defaultPaginationSize
	);
	const [tableData, setTableData] = useState([
		...missingCheckOut,
		...officeHours,
	]);
	const [startDateCalendar, setStartDateCalendar] = useState(false);
	const [endDateCalendar, setEndDateCalendar] = useState(false);
	const [pageNum, setPageNum] = useState(1);
	const [workStatus, setWorkStatus] = useState(StatusID || 0);
	const workStationList = [
		{ value: 0, label: "All" },
		{ value: 1, label: "Work From Home" },
		{ value: 2, label: "Work From Office" },
		{ value: 3, label: "Continuing Work From Office" },
	];
	const [selectedWorkStation, setSelectedWorkStation] = useState(
		WorkStationId
			? workStationList.find(
					(item) => item.value === parseInt(WorkStationId)
			  )
			: { value: 0, label: "All" }
	);
	useEffect(() => {
		const pageSize = getPaginationSizeOnRole(empDesignation);
		setNumberOfItemsPerPage(pageSize);

		getWeeklyHours();
		getTotalHours();
		getOfficeHoursStatus();

		if (WorkStationId) {
			let id = parseInt(WorkStationId);
			let workStation = workStationList.find((item) => item.value === id);
			setSelectedWorkStation(workStation);
			getMyOfficeHours();
		} else if (StatusID) {
			getMyOfficeHours(null, null, null, StatusID);
		} else {
			setSelectedWorkStation({ value: 0, label: "All" });
			getMyOfficeHours(null, null, pageSize);
		}
	}, []);

	const startDateHandleChange = (date) => {
		setStartDate(date);
		getMyOfficeHours("startDate", date);
		getTotalHours("startDate", date);
	};
	const endDateHandleChange = (date) => {
		setEndDate(date);
		getMyOfficeHours("endDate", date);
		getTotalHours("endDate", date);
	};
	const getWeeklyHours = () => {
		axios
			.get(`${myOfficeHoursAPIs.GetWeeklyAndMonthlyHours}`, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then((res) => {
				setWeekHours({
					lastWeekMinutes: res.data.lastWeekMinutes,
					currentWeekMinutes: res.data.currentWeekMinutes,
					currentMonthMinutes: res.data.currentMonthMinutes,
					expectedHours: res.data.expectedHours,
				});
			});
	};
	const getTotalHours = (dateOption, date, status, workStation) => {
		let apiParams = "";
		if (status || status === 0)
			apiParams = {
				startDate: moment(startDate).format(APIDateFormat),
				endDate: moment(endDate).format(APIDateFormat),
				status: status,
				workStation: selectedWorkStation?.value,
			};
		else if (workStation || workStation === 0)
			apiParams = {
				startDate: moment(startDate).format(APIDateFormat),
				endDate: moment(endDate).format(APIDateFormat),
				status: selectedStatus.value,
				workStation: workStation,
			};
		else if (dateOption === "startDate")
			apiParams = {
				startDate: moment(date).format(APIDateFormat),
				endDate: moment(endDate).format(APIDateFormat),
				status: selectedStatus.value,
				workStation: selectedWorkStation?.value,
			};
		else if (dateOption === "endDate")
			apiParams = {
				startDate: moment(startDate).format(APIDateFormat),
				endDate: moment(date).format(APIDateFormat),
				status: selectedStatus.value,
				workStation: selectedWorkStation?.value,
			};
		else
			apiParams = {
				startDate: moment(startDate).format(APIDateFormat),
				endDate: moment(endDate).format(APIDateFormat),
				status: selectedStatus.value,
				workStation: selectedWorkStation?.value,
			};

		axios
			.post(`${myOfficeHoursAPIs.GetTotalHoursAPI}`, apiParams, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then((res) => {
				setTotalHours(res.data);
			});
	};
	const getMyOfficeHours = (dateOption, date, pageSize, StatusId) => {
		let url = "";

		if (dateOption === "startDate")
			url = `${myOfficeHoursAPIs.GetMyOfficeHoursAPI}?StartDate=${moment(
				date || startDate
			).format(APIDateFormat)}&EndDate=${moment(endDate).format(
				APIDateFormat
			)}&PageSize=${numberOfItemsPerPage}&Status=${
				selectedStatus.value
			}&WorkStation=${
				selectedWorkStation ? selectedWorkStation.value : WorkStationId
			}&SortBy=${sortBy.dataField}_${sortBy.order}`;
		else if (dateOption === "endDate")
			url = `${myOfficeHoursAPIs.GetMyOfficeHoursAPI}?StartDate=${moment(
				startDate
			).format(APIDateFormat)}&EndDate=${moment(date || endDate).format(
				APIDateFormat
			)}&PageSize=${numberOfItemsPerPage}&Status=${
				selectedStatus.value
			}&WorkStation=${
				selectedWorkStation ? selectedWorkStation.value : WorkStationId
			}&SortBy=${sortBy.dataField}_${sortBy.order}`;
		else if (pageSize)
			url = `${myOfficeHoursAPIs.GetMyOfficeHoursAPI}?StartDate=${moment(
				startDate
			).format(APIDateFormat)}&EndDate=${moment(endDate).format(
				APIDateFormat
			)}&PageSize=${pageSize}&Status=${
				selectedStatus.value
			}&WorkStation=${
				selectedWorkStation ? selectedWorkStation.value : WorkStationId
			}&SortBy=${sortBy.dataField}_${sortBy.order}`;
		else if (StatusId)
			url = `${myOfficeHoursAPIs.GetMyOfficeHoursAPI}?StartDate=${moment(
				startDate
			).format(APIDateFormat)}&EndDate=${moment(endDate).format(
				APIDateFormat
			)}&PageSize=${numberOfItemsPerPage}&Status=${StatusId}&WorkStation=${
				selectedWorkStation ? selectedWorkStation.value : WorkStationId
			}&SortBy=${sortBy.dataField}_${sortBy.order}&PageNumber=${pageNum}`;
		else
			url = `${myOfficeHoursAPIs.GetMyOfficeHoursAPI}?StartDate=${moment(
				startDate
			).format(APIDateFormat)}&EndDate=${moment(endDate).format(
				APIDateFormat
			)}&PageSize=${numberOfItemsPerPage}&Status=${
				selectedStatus.value
			}&WorkStation=${
				selectedWorkStation ? selectedWorkStation.value : WorkStationId
			}&SortBy=${sortBy.dataField}_${sortBy.order}`;

		axios
			.get(url, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then((res) => {
				setMissingCheckOut(res.data["missingCheckOuts"]);
				setOfficeHours(res.data["myOfficeHours"]);
				setTableData([
					...res.data["missingCheckOuts"],
					...res.data["myOfficeHours"],
				]);
				setWFOPercentage({
					lastMonthWorkFromOfficePercentage:
						res.data.lastMonthWorkFromOfficePercentage,
					thisMonthWorkFromOfficePercentage:
						res.data.thisMonthWorkFromOfficePercentage,
					totalWorkFromOfficePercentage:
						res.data.totalWorkFromOfficePercentage,
				});
				setPagerData(JSON.parse(res.headers["x-pagination"]));
			})
			.catch((err) => {
				if (err.response) {
					if (err.response.status === 500) {
						AlertPopups.ErrorAlert.fire({
							text: `500 Internal Server Error`,
						});
					}
				}
			});
	};

	const getOfficeHoursStatus = () => {
		axios
			.get(`${myOfficeHoursAPIs.GetOfficeHoursStatus}`, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then(({ data, headers }) => {
				let statusList = data.statuses.filter(
					(item) => item.label != "All"
				);
				let sorted = statusList.sort((a, b) =>
					a.label.localeCompare(b.label)
				);
				sorted.unshift({ value: 0, label: "All" });
				setStatus(sorted);
				setWorkStatus(
					StatusID
						? statusList.find(
								(item) => item.value === parseInt(StatusID)
						  ).value
						: 0
				);
				setselectedStatus(
					StatusID
						? statusList.find(
								(item) => item.value === parseInt(StatusID)
						  )
						: {
								value: 0,
								label: "All",
						  }
				);
				setPagerData(JSON.parse(headers["x-pagination"]));
			})
			.catch((err) => {});
	};

	const handleStatus = (obj) => {
		setselectedStatus(obj);
		let statusVal = obj.value;
		setPageNum(1);
		setWorkStatus(statusVal);
		axios
			.get(
				`${myOfficeHoursAPIs.GetMyOfficeHoursAPI}?StartDate=${moment(
					startDate
				).format(APIDateFormat)}&EndDate=${moment(endDate).format(
					APIDateFormat
				)}&Status=${statusVal}&SortBy=${sortBy.dataField}_${
					sortBy.order
				}&PageSize=${numberOfItemsPerPage}&WorkStation=${
					selectedWorkStation
						? selectedWorkStation.value
						: WorkStationId
				}&PageNumber=1`,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then((res) => {
				setMissingCheckOut(res.data["missingCheckOuts"]);
				setOfficeHours(res.data["myOfficeHours"]);
				setTableData([
					...res.data["missingCheckOuts"],
					...res.data["myOfficeHours"],
				]);
				setWFOPercentage({
					lastMonthWorkFromOfficePercentage:
						res.data.lastMonthWorkFromOfficePercentage,
					thisMonthWorkFromOfficePercentage:
						res.data.thisMonthWorkFromOfficePercentage,
					totalWorkFromOfficePercentage:
						res.data.totalWorkFromOfficePercentage,
				});
				setPagerData(JSON.parse(res.headers["x-pagination"]));
			});

		getTotalHours(null, null, statusVal, null);
	};
	const handleWorkStation = (obj) => {
		setSelectedWorkStation(obj);
		let workStationVal = obj.value;
		setPageNum(1);
		axios
			.get(
				`${myOfficeHoursAPIs.GetMyOfficeHoursAPI}?StartDate=${moment(
					startDate
				).format(APIDateFormat)}&EndDate=${moment(endDate).format(
					APIDateFormat
				)}&Status=${selectedStatus.value}&SortBy=${sortBy.dataField}_${
					sortBy.order
				}&PageSize=${numberOfItemsPerPage}&WorkStation=${workStationVal}&PageNumber=1`,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then((res) => {
				setMissingCheckOut(res.data["missingCheckOuts"]);
				setOfficeHours(res.data["myOfficeHours"]);
				setTableData([
					...res.data["missingCheckOuts"],
					...res.data["myOfficeHours"],
				]);
				setWFOPercentage({
					lastMonthWorkFromOfficePercentage:
						res.data.lastMonthWorkFromOfficePercentage,
					thisMonthWorkFromOfficePercentage:
						res.data.thisMonthWorkFromOfficePercentage,
					totalWorkFromOfficePercentage:
						res.data.totalWorkFromOfficePercentage,
				});
				setPagerData(JSON.parse(res.headers["x-pagination"]));
			});

		getTotalHours(null, null, null, workStationVal);
	};
	const startDateOpenCalendar = () => {
		if (startDateCalendar) {
			setStartDateCalendar(false);
		} else {
			setStartDateCalendar(true);
		}
	};
	const endDateOpenCalendar = () => {
		if (endDateCalendar) {
			setEndDateCalendar(false);
		} else {
			setEndDateCalendar(true);
		}
	};
	const formatHours = (mins) => {
		let hours;
		hours = parseInt(mins / 60);
		mins = parseInt(mins % 60);
		if (hours < 10) hours = "0" + hours.toString();
		if (mins < 10) mins = "0" + mins.toString();
		return `${hours}:${mins}`;
	};

	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				empDesignation = userDetails.designation;
				return (
					<div className="container-fluid pl-3 pr-3">
						<Header title="My Office Hours" headerBorder={true} />

						<WeeklyHours
							lastweekHours={formatHours(
								weekHours.lastWeekMinutes
							)}
							totalhours={totalHours
								?.toString()
								.replace(".", ":")}
							currentWeekHours={formatHours(
								weekHours.currentWeekMinutes
							)}
						/>
						<MonthlyPercentage
							lastweekHours={
								WFOPercentage.lastMonthWorkFromOfficePercentage
							}
							currentWeekHours={
								WFOPercentage.thisMonthWorkFromOfficePercentage
							}
							totalhours={
								WFOPercentage.totalWorkFromOfficePercentage
							}
						/>
						<StatusBar
							startDateHandleChange={startDateHandleChange}
							endDateHandleChange={endDateHandleChange}
							startDate={startDate}
							endDate={endDate}
							status={status}
							selectedStatus={selectedStatus}
							handleStatus={handleStatus}
							startDateOpenCalendar={startDateOpenCalendar}
							endDateOpenCalendar={endDateOpenCalendar}
							startDateCalendar={startDateCalendar}
							endDateCalendar={endDateCalendar}
							workStationList={workStationList}
							selectedWorkStation={selectedWorkStation}
							handleWorkStation={handleWorkStation}
						/>
						<HoursTable
							status={status}
							workStation={
								WorkStationId || selectedWorkStation.value
							}
							startDate={startDate}
							endDate={endDate}
							tableData={tableData}
							setTableData={setTableData}
							setOfficeHours={setOfficeHours}
							setMissingCheckOut={setMissingCheckOut}
							numberOfItemsPerPage={numberOfItemsPerPage}
							pageNum={pageNum}
							setPageNum={(value) => setPageNum(value)}
							setNumberOfItemsPerPage={(value) =>
								setNumberOfItemsPerPage(value)
							}
							pagerData={pagerData}
							workStatus={workStatus}
							setPagerData={setPagerData}
							setSortBy={setSortBy}
						/>
					</div>
				);
			}}
		</UserConsumer>
	);
};

export default OfficeHours;
